import { ActionType, createAction } from "typesafe-actions";

import { EntityType } from "@mapmycustomers/shared/enum";
import { AnyEntityId } from "@mapmycustomers/shared/types/entity";

import EntityViewPayload from "./EntityViewPayload";

export const showEntityView = createAction("@viewRecord/showEntityView")<EntityViewPayload>();

export const clearEntityViewReturnState = createAction(
  "@viewRecord/clearEntityViewReturnState"
)<void>();

export const hideEntityView = createAction("@viewRecord/hideEntityView")<void>();

export const openEntity = createAction("@viewRecord/openEntity")<{
  entityId: AnyEntityId;
  entityType: EntityType;
}>();

export const setEntityTypesWithExternalPreview = createAction(
  "@viewRecord/setEntityTypesWithExternalPreview"
)<EntityType[]>();

export const showRandomRecord = createAction("@viewRecord/showRandomRecord")<void>();

export type Actions = ActionType<
  | typeof clearEntityViewReturnState
  | typeof hideEntityView
  | typeof openEntity
  | typeof setEntityTypesWithExternalPreview
  | typeof showEntityView
  | typeof showRandomRecord
>;
